import BaseComponent from "../base-component.js";

class GriddedQuestionComponent extends BaseComponent {
  responseCollector() {
    let selectedValues = this.props.studentResponse?.gridded?.selected_values || Array((this.props.item.responseDeclaration.grid_columns || []).filter((column) => column.type == "input").length).fill(null);
    let columns = this.props.item.responseDeclaration.grid_columns
    let inputColumnIndex = -1;
    if(columns) {
      return <div class="response-collector gridded">
        {columns.map((column) => {
          if(column.type == "static") {
            if(column.value) {
              return <div class="response-col">
                <div class="answer">
                  <div class="static gridded-cell">{column.value}</div>
                </div>
              </div>
            }
          } else if(column.cells) {
            inputColumnIndex += 1;
            let index = inputColumnIndex
            let cells = column.cells
            return <div class="response-col">
              <div class="answer">
                <input type="text" value={selectedValues[index] || ""} maxLength={1} onChange={(e) => {
                  if(cells.find((cell) => cell.value == e.currentTarget.value)) {
                    this.handleInput(e.currentTarget.value, index)
                  } else {
                    e.currentTarget.value = ""
                  }
                }}/>
                {column.cells.map((cell) => {
                  return <button class={`button gridded-cell ${selectedValues[index] == cell.value ? "selected" : ""}`} onClick={() => {this.handleInput(cell.value, index)}}>{cell.display ? cell.display : cell.value}</button>
                })}
              </div>
            </div>
          }
        })}
      </div>
    }
  }

  /**
   * @param {string} value 
   * @param {number} index 
   */
  handleInput(value, index) {
    let inputColumnCount = (this.props.item.responseDeclaration.grid_columns || []).filter((column) => column.type == "input").length
    //@type {(string|null)[]}
    let selectedValues = this.props.studentResponse?.gridded?.selected_values || Array(inputColumnCount).fill(null)
    this.props.updateStudentResponse({gridded: {selected_values: selectedValues.map((v, i) => i == index ? value : v)}})
    if(this.base instanceof HTMLElement) {
      let focusedInput = this.base.querySelector(".answer input:focus");
      if(focusedInput && focusedInput instanceof HTMLInputElement) {
        focusedInput.blur();
        let col = focusedInput.closest(".response-col")
        if(col) {
          let nextCol = col.nextElementSibling;
          if(nextCol) {
            let input = nextCol.querySelector("input");
            if(input && input instanceof HTMLInputElement) {
              input.focus();
            }
          }
        }
      }
    }
  }

  render() {
    return(this.wrapper(this.body(), this.responseCollector()));
  }
}

export default GriddedQuestionComponent